import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.scss';
import logo from '../assets/logo.png';

const Footer = () => {
    const location = useLocation();

    const handleClick = (e, path) => {
        if (location.pathname === path) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <footer>
            <div className="footer-container">
                <Link to="/" className="logo" onClick={(e) => handleClick(e, '/')}>
                    <img src={logo} alt="CHAIropractic" />
                </Link>
                <div className="footer-links">
                    <Link to="/" onClick={(e) => handleClick(e, '/')}>Home</Link>
                    <Link to="/services" onClick={(e) => handleClick(e, '/services')}>Services</Link>
                    <Link to="/about" onClick={(e) => handleClick(e, '/about')}>About</Link>
                    <Link to="/conditions" onClick={(e) => handleClick(e, '/conditions')}>Conditions</Link>
                    <Link to="/contact" onClick={(e) => handleClick(e, '/contact')}>Contact</Link>
                </div>
                <p>&copy; 2025 CHAIropractic. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;

